import type { AuthSession, PermissionCode } from '@ldembalagens/types';
import { create } from 'zustand';

export type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'anonymous';

interface AuthState {
  status: AuthStatus;
  accessToken: string | null;
  session: Omit<AuthSession, 'accessToken' | 'expiresIn'> | null;
  permissions: Set<PermissionCode>;
  setSession: (session: AuthSession) => void;
  setStatus: (status: AuthStatus) => void;
  clear: () => void;
}

/**
 * Estado de autenticação mantido apenas em memória (o access token nunca vai
 * para localStorage). Ao recarregar a página, a sessão é restaurada via
 * `POST /auth/refresh` com o cookie HttpOnly.
 */
export const authStore = create<AuthState>((set) => ({
  status: 'idle',
  accessToken: null,
  session: null,
  permissions: new Set(),
  setSession: (session) => {
    const { accessToken, expiresIn: _expiresIn, ...rest } = session;
    set({
      status: 'authenticated',
      accessToken,
      session: rest,
      permissions: new Set(rest.permissions),
    });
  },
  setStatus: (status) => set({ status }),
  clear: () =>
    set({ status: 'anonymous', accessToken: null, session: null, permissions: new Set() }),
}));

export const useAuthStore = authStore;
